import { PageLoader } from "@/components/ui/Spinner";

import { useBillingPeriods } from "../hooks/useEmployeeAgreements";
import { BillingPeriodRow } from "../components/BillingPeriodRow";

export function MyBillingPeriodsPage() {
  const { data: periods = [], isLoading } = useBillingPeriods();

  if (isLoading) return <PageLoader />;

  return (
    <div className="p-6 flex flex-col gap-4">
      <h1 className="text-lg font-mono uppercase tracking-wider">
        Moje rozliczenia podpisów
      </h1>
      {periods.length === 0 ? (
        <div className="text-sm text-[var(--color-text-muted)] py-8 text-center">
          Brak okresów rozliczeniowych. Generowane automatycznie 1-go każdego miesiąca.
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          {periods.map((p) => (
            <BillingPeriodRow key={p.id} period={p} />
          ))}
        </div>
      )}
    </div>
  );
}
